import moment from 'moment';

export const requestWrapper = (data) => ({ data });

export const modules = [
  { id: 0, name: 'Staff', value: 'ADMIN_ADMIN' },
  { id: 1, name: 'Clients', value: 'ADMIN_ISSUER' },
  { id: 2, name: 'Activity Logs', value: 'ADMIN_ACTIVITY_LOG' },
  { id: 3, name: 'TPI', value: 'ADMIN_TPI' },
  { id: 4, name: 'Topup', value: 'ADMIN_TOPUP' },
  { id: 6, name: 'Routes', value: 'ADMIN_ROUTE' },
  { id: 7, name: 'API access key', value: 'ADMIN_API_ACCESS_KEY' },
  { id: 8, name: 'request history', value: 'ADMIN_GW_REQUEST_HISTORY' },
  { id: 10, name: 'Reports', value: 'ADMIN_REPORT' }
];

export const issuerModules = [
  { id: 0, name: 'Staff Manager', value: 'ISSUER_ISSUER' },
  { id: 1, name: 'Activity Logs', value: 'ISSUER_ACTIVITY_LOG' },
  // { id: 2, name: 'Key Manager', value: 'ISSUER_KEY_MANAGER' },
  { id: 3, name: 'Topup', value: 'ISSUER_TOPUP' },
  { id: 4, name: 'Routes', value: 'ISSUER_ROUTE' },
  { id: 5, name: 'API access key', value: 'ISSUER_API_ACCESS_KEY' },
  { id: 6, name: 'request history', value: 'ISSUER_GW_REQUEST_HISTORY' },
  { id: 7, name: 'Reports', value: 'ISSUER_REPORT' }
];

export function getMonthDay(date) {
  return moment.unix(date).format('MMM Do');
}

export const processGraphInfo = (dataSet = [], title, xAxis, yAxis, isDate) => {
  const graphSet = {
    name: [],
    count: []
  };

  if (dataSet === null || dataSet.length === 0) return graphSet;

  dataSet.map((item) => {
    if (title) {
      let xAxisLabel = item[title][xAxis];
      if (title == 'route') {
        const index = xAxisLabel.lastIndexOf('/');
        xAxisLabel = xAxisLabel.substring(index);
      }
      graphSet.name.push(isDate ? getMonthDay(item[title][xAxis]) : xAxisLabel);
    } else graphSet.name.push(isDate ? getMonthDay(item[xAxis]) : item[xAxis]);
    graphSet.count.push(item[yAxis]);
  });

  return graphSet;
};

export const getLastNDays = (n) => {
  return moment().subtract(n, 'd').format('YYYY-MM-DD');
};

export const convertDateToUnix = (date) => moment(date).unix();

//  <Box alignItems="center" display="flex" ml={-1}>
//                   <Checkbox
//                     checked={values.policy}
//                     name="policy"
//                     onChange={handleChange}
//                   />
//                   <Typography color="textSecondary" variant="body1">
//                     I have read the{' '}
//                     <Link
//                       color="primary"
//                       component={RouterLink}
//                       to="#"
//                       underline="always"
//                       variant="h6"
//                     >
//                       Terms and Conditions
//                     </Link>
//                   </Typography>
//                 </Box>
//                 {Boolean(touched.policy && errors.policy) && (
//                   <FormHelperText error>{errors.policy}</FormHelperText>
//                 )}
